/** @type {import('tailwindcss').Config} */

const secondaryColor = '#913ef0';
const errorColor = '#E54963';
// const infoColor = '#4B80E7';
const warningColor = '#FFB946';
const successColor = '#5ae399';


// paste this to see colors
{/* <div className="flex my-4">
<div className="p-4 bg-primary" />
<div className="p-4 bg-primary-light" />
<div className="p-4 bg-primary-lighter" />
<div className="p-4 bg-primary-lightest" />
<div className="p-4 bg-secondary" />
<div className="p-4 bg-secondary-light" />
<div className="p-4 bg-secondary-lighter" />
<div className="p-4 bg-secondary-lightest" />
</div> */}

module.exports = {
	// content: [],
	// content: ["./src/**/*.{js,jsx,ts,tsx}"],
	important: true,
	content: [
		// './storage/framework/views/*.php',
		// './resources/**/*.blade.php',
		'./resources/assets/react/**/*.js',
		'./resources/assets/js/**/*.js',
		// './resources/**/*.vue',
],
    safelist: [
        'bg-purple-500',
        'bg-yellow-500',
        'bg-blue-500',
        'bg-pink-500',
        'bg-green-500',
        'bg-indigo-500',
        'bg-gray-500',
        'bg-emerald-500',
        'bg-red-500',
        'bg-violet-500',
        'bg-amber-500',
        'bg-cyan-500',
        'bg-slate-500',
        'bg-teal-500',
        'bg-rose-500',
        'bg-orange-500',
        'bg-lime-500',
    ],
// finish getting color scheme from laravel.config.THEME in console
	theme: {
		extend: {
			colors: {
				primary: {
					lightest: '#B896FF',
					lighter: '#8563D7',
					light: '#6C4ABE',
					DEFAULT: '#5F3DB1',
					dark: '#5230A4',
					darker: '#39178B',
					darkest: '#060058',
					100: '#8B63E7',
				},
				secondary: {
					lightest: '#EA97FF',
					lighter: '#B764FF',
					light: '#9E4BFD',
					DEFAULT: '#913EF0',
					dark: '#8431E3',
					darker: '#6B18CA',
					darkest: '#380097',
				},
				charcoal: {
					300: '#5B5D6E',
				},
				dark: {
					gray: '#343741',
				},
				light: {
					gray: '#EFEFEF',
					gray2: '#E5E5E5',
					gray3: '#F5F6F8',
					gray4: '#8C9298',
					gray5: '#D3D8DD',
					gray6: '#707683',
				},
				bluegray: "#E5EBF1",
				danger: {
					DEFAULT: '#E54963',
					// DEFAULT: '#61E29B',
				},
				success: {
					DEFAULT: '#5AE399'
				},
				skyblue: '#0090FF',


				// Color styles from figma
				wrippleDangerDark: '#D83C56',
				wrippleLightDarker: '#BFC5CB',
				wrippleLightDarkest: '#8C9298',
				wrippleLightSemitransparent: '#E5EBF1',
				wrippleLightLight: '#F2F8FE',
				wripplePrimaryYellow: warningColor, // @warning-color
				wripplePrimaryDarkPurple: '#5f3db1',
				wripplePrimaryBlack: '@black',
				wripplePrimaryDarkNavy: '#343741',
				wrippleWhite: '#FFFFFF',
				wripplePrimaryPaleRed: errorColor,
				wripplePrimaryMediumBlue: '#4B80E7',
				wripplePrimaryBrightPurple: secondaryColor,
				wripplePrimaryPaleGreen: successColor, // '@success-color',
				wrippleSuccessLight: '#67F0A6',
				wrippleSuccessDarker: '#34bd73',
				wrippleLightGrayBg: '#E5E5E5',
				wripplePrimaryNavy: '#192A3E',
				wrippleBlueGray: '#334D6E',
				wripplePrimaryLightGray: '#D3D8DD',
				wrippleOffWhite: '#F5F6F8',
				wripplePrimaryLightBlue: '#90A0B7',
				wripplePrimaryRuleBlue: '#E5EBF1',
				wrippleAlternateDark: '#5230A4',
				wrippleAlternateDarker: '#39178B',
				wrippleAlternateDarkest: '#060058',
				wrippleAlternateLight: '#6C4ABE',
				wrippleAlternateLighter: '#8563D7',
				wrippleAlternateLightest: '#B896FF',
			},
			fontFamily: {
				'primary': ['Beatrice', 'sans-serif'],
				'secondary': ['Poppins', 'sans-serif'],
			},
			fontSize: {
                'xxs': '0.625rem', // matches size w-2.5
            },
			screens: {
				'xs': '460px',
			},
		},
	},
	plugins: [],
}